import { z } from 'zod';
import superjson from 'superjson';
import { ChatAttachmentItem } from './list_GET.schema';

export const schema = z.object({
  attachmentId: z.string().min(1),
  isPrivate: z.boolean().optional(),
  sharedWith: z.string().optional(), // Comma-separated user IDs or emails
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  attachment: ChatAttachmentItem;
  shareUrl: string | null;
};

export const shareChatAttachment = async (
  body: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const validatedInput = schema.parse(body);
  const result = await fetch(`/_api/chat-attachments/share`, {
    method: 'POST',
    credentials: 'include',
    body: superjson.stringify(validatedInput),
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
